import { render } from "./verifyTransaction.vue?vue&type=template&id=6acf4ee4"
import script from "./verifyTransaction.vue?vue&type=script&lang=js"
export * from "./verifyTransaction.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__